if (!customElements.get('product-selector')) {
  class ProductSelector extends HTMLElement {
    constructor() {
      super();

      this.cacheDom();
      this.initState();
    }

    connectedCallback() {

      const unavailable = theme.variantStrings.unavailable || 'Unavailable';

      this.unavailableText = ` - ${unavailable}`;

      this.addEventListener('change', this.handleVariantChange);
    }

    disconnectedCallback() {
      // Remove event listeners
      this.removeEventListener('change', this.handleVariantChange);

      this.forms = null;
      this.mainProduct = null;
      this.cartDrawer = null;
      this.currentVariant = null;
      this.selectedOptions = null;
    }

    // --------------------------
    // Setup
    // --------------------------

    cacheDom() {
      this.cartDrawer = document.querySelector('side-cart');
      this.mainProduct = this.closest('quick-add-modal') ||  this.closest('main-product');
      this.forms = this.mainProduct?.querySelectorAll(
        '.js-product-form-main, .js-instalments-form'
      );

      this.variants = this.getVariants() || [];
      this.availableVariants = this.variants.filter(v => v.available);
    }

    initState() {
      this.selectedOptions = this.getSelectedOptions();
      this.currentVariant = this.getSelectedVariant();
      this.setUnavailableOptions();
      this.handleAddButton();
      this.updateMedia({});
       this.updatePickupAvailability();
    }



    // --------------------------
    // Events
    // --------------------------

    handleVariantChange = (evt) => {
      this.selectedOptions = this.getSelectedOptions();
      this.currentVariant = this.getSelectedVariant();
      this.selectedOption = this.getSelectedOptionElement(evt);
      this.setUnavailableOptions();
      this.handleAddButton();

      if (!this.currentVariant) return;
      this.updateUrl();
      this.updateLabel();
      this.updateVariantInput();
      this.fetchProductInfo();
       this.updatePickupAvailability();
      // console.log('Current Variant:', this.currentVariant);



      this.updateMedia({
        name: evt.target.dataset.name,
        value: evt.target.value
      });


    };



    updateUrl = (sellingPlanId = null) => {

      if (!this.currentVariant) return;
      const newUrl = this.selectedOption?.dataset?.connectedProductUrl;
      const baseUrl = newUrl || window.location.pathname;
      const params = new URLSearchParams(window.location.search);
      // Always update variant
      params.set('variant', this.currentVariant.id);

      if (sellingPlanId && sellingPlanId !== '0') {
        params.set('selling_plan', sellingPlanId);
      } else {
        params.delete('selling_plan');
      }
      const finalUrl = `${baseUrl}?${params.toString()}`;
      window.history.replaceState({}, '', finalUrl);

    }


    updateLabel() {
      const valueHolder = this.selectedOption?.closest('fieldset')?.querySelector('[data-option-selected-value]');
      if (!valueHolder) return;
      const value =
        this.selectedOption?.getAttribute('aria-label')?.trim() ||
        this.selectedOption?.dataset?.value?.trim() ||
        this.selectedOption?.textContent?.trim() ||
        this.selectedOption?.value?.trim() ||
        '';

      valueHolder.textContent = value;
    }

    fetchProductInfo(ignoreSellingPlan = false) {
      const params = new URLSearchParams(window.location.search);
      params[params.has('variant') ? 'set' : 'append'](
        'variant',
        this.currentVariant.id
      );
      params.append('section_id', this.dataset.sectionId);
      if (ignoreSellingPlan) params.delete('selling_plan');


      fetch(`${this.dataset.productUrl}?${params.toString()}`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          this.updateLiveRegions(html);
        });


    }

    updateLiveRegions(html) {
      const regions = [
        `#Product-Price-${this.dataset.sectionId}`,
        `#Product-Inventory-${this.dataset.sectionId}`,
        `#Product-Sku-${this.dataset.sectionId}`,
      ];

      const container =
    this.closest('quick-add-modal') ||
    this.closest('main-product') ||
    document;



      const sourceHTML = html;
      regions.forEach(region => {
        const destination = container.querySelector(region);
        const source = sourceHTML.querySelector(region);

        if (!destination || !source) return;
        destination.classList.remove('visibility-hidden');
        destination.innerHTML = source.innerHTML;
      });


    }
    setUnavailableOptions() {
      const contexts = document.querySelectorAll('product-selector, sticky-product-info');
      contexts.forEach(el => {
        if (el && typeof el.updateOptionAvailability === 'function') {
          el.updateOptionAvailability(el);
        }
      });

    }

    updateMedia(data) {
      if (!this.currentVariant) return;
        const container = this.closest('.product-container') || this.closest('quick-add-modal');


      const productMedia = container?.querySelector('product-media');
      if (!productMedia) return;

      const mediaId = this.currentVariant?.featured_media?.id;
      if (!mediaId) return;


      const swiperEl = productMedia.querySelector('.product__swiper');

      let targetIndex = -1;
      let targetSlide = null;

      if (swiperEl) {
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        slides.forEach((slide, index) => {
          const slideMediaId = slide.getAttribute('data-media-id');
          if (Number(slideMediaId) === Number(mediaId)) {
            targetIndex = index;
            targetSlide = slide;
          }
        });

        // Remove selected from all & add to active one
        slides.forEach(slide => slide.classList.remove('selected'));
        if (targetSlide) targetSlide.classList.add('selected');
      }

      if (swiperEl && swiperEl.swiper) {
        // If swiper is active
        swiperEl.swiper.slideTo(targetIndex, 300);
      } else if (targetSlide) {
        // If swiper is not active, scroll to the image
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        console.warn('[changeMedia] No matching slide found for mediaId:', mediaId);
      }


     if (!productMedia) return;
      if (productMedia.hasAttribute('data-gallery-filter')) {
        productMedia.filterMedia(data);

   
        return;
      }

 
    }




    updatePickupAvailability() {
    const pickUpAvailability = document.querySelector(`pickup-availability.pickup-availability--${this.dataset.sectionId}`);
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if (pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }


    isSelectedElement(el) {
      return (
        (el.type === 'radio' && el.checked) ||
        (el.tagName === 'OPTION' && el.selected) ||
        (el.classList.contains('js-option') &&
          el.getAttribute('aria-selected') === 'true')
      );
    }


    /**
     * Checks if a variant exists for this option, considering prior selections
     */
    isOptionAvailable(index, value) {
      const currentHandle = `option${index + 1}`;
      const valuesToCheck = {};

      // Include all previously selected options
      for (let i = 0; i < index; i++) {
        const handle = `option${i + 1}`;
        valuesToCheck[handle] = this.selectedOptions[i].value;
      }

      // Add the current option being checked
      valuesToCheck[currentHandle] = value;
      // Return true if any available variant matches all of these selections
      return this.availableVariants.some(variant =>
        Object.entries(valuesToCheck).every(
          ([handle, val]) => variant[handle] === val
        )
      );
    }



    handleAddButton() {
      if (!this.forms) return;

      this.forms.forEach(form => {
        const addButton = form.querySelector('[type="submit"]');
        if (!addButton) return;

        const textSpans = addButton.querySelectorAll(
          '.button--text > span, .hover--text > span'
        );

        let text;

        if (!this.currentVariant) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
          text = theme.variantStrings.unavailable;
        }
        else if (!this.currentVariant.available) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
          text = theme.variantStrings.soldOut || 'Sold out';
        }
        else {
          addButton.disabled = false;
          addButton.setAttribute('aria-disabled', 'false');
          text = theme.variantStrings.addToCart;
        }

        // Update both visible and hover text
        textSpans.forEach(span => {
          span.textContent = text;
        });
      });
    }



    /**
   * Appends string to an element's innerHTML.
   *
   * @param {HTMLElement} el
   * @param {String} string
   * @returns {Void}
   */
    appendStringToElementHTML(el, string) {
      if (el.innerHTML.includes(string)) return;
      el.innerHTML = `${el.innerHTML}${string}`;
    }

    /**
     * Removes unavailable text from a select option.
     *
     * @param {HTMLElement} el
     * @param {String} string
     * @returns {Void}
     */
    removeStringFromElementHTML(el, string) {
      el.innerHTML = el.innerHTML.replace(string, '');
    }

    // --------------------------
    // Variant Logic
    // --------------------------

    getVariants() {
      const el = this.querySelector('[data-variants]');
      return el ? JSON.parse(el.textContent) : [];
    }

    getSelectedOptionElement(evt) {
      const target = evt.target;
      if (!target) return null;

      // Native select
      if (target.tagName === 'SELECT') {
        return target.options[target.selectedIndex];
      }

      // Radio
      if (target.type === 'radio') {
        return target;
      }

      // Custom select
      const customSelect = target.closest('custom-select');
      if (customSelect) {
        return customSelect.querySelector('.js-option[aria-selected="true"]');
      }
      return null;
    }


    getSelectedOptions() {
      return Array.from(
        this.querySelectorAll(
          'input[type="radio"]:checked, select, custom-select'
        ),
        (el) => {
          if (el.tagName.toLowerCase() === 'custom-select') {
            const selected = el.querySelector(
              '.js-option[aria-selected="true"]'
            );
            return {
              name: selected?.dataset.name || null,
              value: selected?.dataset.value || null
            };
          }
          return { name: el.dataset.name, value: el.value };
        }
      );
    }


    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      if (!selectedOptions.length) return this.variants[0] || null;

      return (
        this.variants.find((variant) =>
          variant.options.every((option, index) => {
            const selected = selectedOptions[index];
            // match by value only (or you could match by name if needed)
            return selected && option === selected.value;
          })
        ) || null
      );
    }


    updateVariantInput() {
      if (!this.currentVariant || !this.forms) return;

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }




  }

  customElements.define('product-selector', ProductSelector);
}
